import React, { useState, useEffect } from 'react'
import Sidebar from '../../studentDashboard/pages/sidebarstudent'
import Header from '../../studentDashboard/pages/Headerstudent'
import { Row, Col } from 'react-bootstrap'
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { StudentMessTodaysMenuFindall } from '../../ApiFile'
import { FaMoon, FaUtensils } from 'react-icons/fa'
import MobileNavbar from '../../studentDashboard/pages/MobileNavbar'

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels)

const StudentTodaysMenu = () => {
  const [lunchData, setLunchData] = useState(null)
  const [dinnerData, setDinnerData] = useState(null)

  useEffect(() => {
    // Fetch the today's menu data from the API
    fetch(StudentMessTodaysMenuFindall)
      .then((response) => response.json())
      .then((data) => {
        // Update the lunch data
        setLunchData({
          labels: data.lunch.map((item) => item.menu),
          datasets: [
            {
              data: data.lunch.map(() => 15), // Example data values, modify as needed
              backgroundColor: [
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#9966FF',
                '#FF9F40',
                '#FFCD56',
              ],
            },
          ],
        })

        // Update the dinner data
        setDinnerData({
          labels: data.dinner.map((item) => item.menu),
          datasets: [
            {
              data: data.dinner.map(() => 20), // Example data values, modify as needed
              backgroundColor: [
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#9966FF',
                '#FF9F40',
              ],
            },
          ],
        })
      })
      .catch((error) => {
        console.error('Error fetching the menu data:', error)
      })
  }, [])

  // Chart options with datalabels plugin
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Allows chart to resize better
    plugins: {
      legend: {
        display: false, // Hide the legend since labels will be on the chart
      },
      datalabels: {
        color: '#000', // Text color for the labels
        formatter: (value, context) => {
          return context.chart.data.labels[context.dataIndex]
        },
        font: {
          weight: 'bold',
        },
      },
    },
  }

  return (
    <>
       <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
               {/* Sidebar on the left for desktop */}
               <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
                 <Sidebar />
               </div>
         
               {/* Main content on the right */}
               <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
                 <Header />
           
                 <div className="d-block d-md-none">
                   <MobileNavbar />
                 </div>

         <div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
              Mess Today's Menu
            </h5>
          </div>

          <Row style={{ display: 'flex', justifyContent: 'space-evenly' }}>
            <Col xs={12} md={2}></Col>
            <Col xs={12} md={4} className="text-center mt-5">
              <h4>Lunch</h4>
              <div style={{ height: '300px' }}>
                {lunchData && <Pie data={lunchData} options={options} />}
              </div>
                {lunchData && (
                                          <Row className="mt-3 justify-content-center">
                                            {lunchData.labels.map((menuItem, index) => (
                                              <Col xs={6} key={index} className="mb-2">
                                                <div
                                                  className="d-flex align-items-center justify-content-center"
                                                  style={{
                                                    backgroundColor: '#ffea8bff',
                                                    padding: '6px',
                                                    borderRadius: '10px',
                                                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                    color:"black",
                                                  }}
                                                >
                                                  {/* <FaUtensils style={{ color: 'green', marginRight: '6px' }} /> */}
                                                  <span style={{ whiteSpace: 'nowrap' }}>{menuItem}</span>
                                                </div>
                                              </Col>
                                            ))}
                                          </Row>
                                        )} 
            </Col>
            <Col xs={12} md={4} className="text-center mt-5">
              <h4>Dinner</h4>
              <div style={{ height: '300px' }}>
                {dinnerData && <Pie data={dinnerData} options={options} />}
              </div>
               {dinnerData && (
                                        <Row className="mt-3 justify-content-center">
                                          {dinnerData.labels.map((menuItem, index) => (
                                            <Col xs={6} key={index} className="mb-2">
                                              <div
                                                className="d-flex align-items-center justify-content-center"
                                                style={{
                                                  backgroundColor: '#aef3ffff',
                                                  padding: '6px',
                                                  borderRadius: '10px',
                                                  boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                  color:"black",
                                                }}
                                              >
                                                {/* <FaUtensils style={{ color: 'blue', marginRight: '6px' }} /> */}
                                                <span style={{ whiteSpace: 'nowrap' }}>{menuItem}</span>
                                              </div>
                                            </Col>
                                          ))}
                                        </Row>
                                      )}
            </Col>
            <Col xs={12} md={2}></Col>
          </Row>
        </div>
      </div>
      </div>
    </>
  )
}

export default StudentTodaysMenu
